import { wrapClientApiCall } from '../../../utils'

export const forgotPassword = ({ email }) =>
    wrapClientApiCall({
        actionRoot: 'FORGOT_PASSWORD',
        url: `resend_activation`,
        method: 'POST',
        body: { email },
    })
